<template>
  <div class="targets-type" :class="{ 'targets-type--with-label': label }">
    <TargetsTypeIcon :icon="iconValue" class="targets-type__icon" />
    <span v-if="label" class="targets-type__label">{{ typeLabel }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import TargetsTypeIcon from "../TargetsTypePicker/TargetsTypeIcon.vue";

const TARGET_TYPES = ["Fixed", "Prorated"];

const props = defineProps({
  type: {
    type: String,
    default: "Fixed",
    validator: (value) => ["Fixed", "Prorated"].includes(value),
  },
  label: {
    type: Boolean,
    default: false,
  },
});

const iconValue = computed(() => (TARGET_TYPES.includes(props.type) ? props.type : "Fixed"));

// Get the label text
const typeLabel = computed(() => {
  return props.type;
});
</script>

<style scoped>
.targets-type {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.targets-type__icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

/* Dark gray icon when label is false - override all strokes and non-light-gray fills */
.targets-type:not(.targets-type--with-label) .targets-type__icon :deep(svg *) {
  stroke: #344054 !important; /* Dark gray for all strokes */
}

.targets-type:not(.targets-type--with-label) .targets-type__icon :deep(svg circle[fill="#E0E0E0"]),
.targets-type:not(.targets-type--with-label) .targets-type__icon :deep(svg rect[fill="#E0E0E0"]) {
  fill: #E0E0E0 !important; /* Keep light gray fills */
}

.targets-type:not(.targets-type--with-label) .targets-type__icon :deep(svg rect[fill]:not([fill="#E0E0E0"]):not([fill="none"])) {
  fill: #344054 !important; /* Dark gray for black fills */
}

/* Light gray icon when label is true - override all strokes and non-light-gray fills */
.targets-type--with-label .targets-type__icon :deep(svg *) {
  stroke: #667085 !important; /* Light gray for all strokes */
}

.targets-type--with-label .targets-type__icon :deep(svg circle[fill="#E0E0E0"]),
.targets-type--with-label .targets-type__icon :deep(svg rect[fill="#E0E0E0"]) {
  fill: #E0E0E0 !important; /* Keep light gray fills */
}

.targets-type--with-label .targets-type__icon :deep(svg rect[fill]:not([fill="#E0E0E0"]):not([fill="none"])) {
  fill: #667085 !important; /* Light gray for black fills */
}

.targets-type__icon :deep(svg circle),
.targets-type__icon :deep(svg path),
.targets-type__icon :deep(svg rect) {
  transition: stroke 0.2s ease, fill 0.2s ease;
}

.targets-type__label {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #0F1828;
  white-space: nowrap;
}
</style>
